import types from './types';
import { resourceActionsGenerator } from '../../utils';

export default {
  ...resourceActionsGenerator('customerFaq', types),
};
